import * as React from 'react';


export function WaitingForTimer(props: {}) {
  return (
    <>
      <div className="spinner-grow text-primary" role="status">
        <span className="sr-only">waiting...</span>
      </div>
      <h3>waiting for start...</h3>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/Timer/WaitingForTimer.tsx